import React from 'react';
import Modal2 from 'components/commons/modal/Modal2';
import { useRouting } from 'hooks/useRouting';
import { formatDateForString } from 'utils/formatter';
import { userBrokerProps } from 'pages/DividendDeposit';

export const DividendStoppingAccountModal = ({
  hide,
  isShow,
  brokerList,
}: {
  isShow: boolean;
  hide: () => void;
  brokerList: userBrokerProps[];
}): React.ReactElement => {
  const routing = useRouting();
  const goSecurityaccounts = (): void => {
    routing.pushRouting({ path: '/securityaccounts' }, true);
  };

  return (
    <>
      <Modal2 isShow={isShow}>
        <div className="p-4 max-h-modal overflow-y-auto text-sm text-bluegray-700">
          <div className="flex flex-row">
            <div className="flex-grow text-lg font-bold text-gray-800">
              連携停止中の口座があります
            </div>
            <div
              className="icon-close ml-auto text-gray-500 cursor-pointer"
              onClick={hide}
            />
          </div>
          <div className="mt-4 text-sm">
            {brokerList.map((list, i) => {
              return (
                <div className="flex flex-row" key={i}>
                  <div>{list.brokerName}</div>
                  {list.status === '000' ? (
                    <div className="ml-auto">
                      {formatDateForString(
                        list.updTime,
                        'yyyy/MM/dd(ddd) HH:mm'
                      )}
                    </div>
                  ) : (
                    <div className="flex flex-row items-center justify-center ml-auto text-red-500">
                      <div className="icon-alert" />
                      <div className="ml-2.5">更新失敗</div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          <div className="mt-4 text-sm">
            次のいずれかの理由に該当するため最新のデータを取得できませんでした。
          </div>
          <div className="mt-4 mb-2 text-sm">
            （1）接続先の金融機関がメンテナンス中
            <br />
            （2）接続先の金融機関のログインID/パスワードを変更。もしくはアカウントロックされている
            <br />
            （3）接続先の金融機関にお客様の確認が必要なメッセージがある
            <br />
            （4）一時的に接続しづらくなっている場合
          </div>
          <button
            className="mt-4 p-2 justify-center w-full text-sm text-bluegray-500"
            onClick={() => goSecurityaccounts()}>
            連携口座一覧を確認
          </button>
          <button
            className="mt-4 p-2 justify-center w-full text-sm text-bluegray-500"
            onClick={hide}>
            閉じる
          </button>
        </div>
      </Modal2>
    </>
  );
};
